// Generated by Melange

import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function MainPage(Props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                      className: "w-30 h-30",
                      src: StaticAsset.src("/static/images/cart-empty.png")
                    }),
                JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                      className: "mt-6 text-center text-gray-medium",
                      children: "Тут скоро будет главная страница кабинета."
                    }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                      className: "mt-4 lg:w-110 text-center text-gray-medium",
                      children: "В данном разделе будут показаны графики с показателями финансов, баланс, счета — в общем, вся важная информация о вашей компании."
                    })
              ],
              className: "flex flex-col items-center w-full lg:bg-gray-pale py-30 px-10 lg:px-0 flex-1"
            });
}

const make = MainPage;

export {
  make ,
}
/* Buhta_components__Text Not a pure module */
